import axios, { AxiosInstance, AxiosRequestHeaders } from "axios";
import Router from "next/router";

import type { GetServerSidePropsContext, NextPageContext } from "next";

import transcodeLocale from "helpers/transcodeLocale";
import Cookies from "js-cookie";

import type { CustomRequest } from "types/request";

const hybridHttpClient = (
  ctx?: GetServerSidePropsContext | NextPageContext,
): AxiosInstance => {
  let locale;
  let baseURL;
  let authorizationToken;

  if (ctx) {
    // Server side
    const customReq = ctx.req as CustomRequest;

    locale = ctx.locale;
    baseURL = `${process.env.GATEWAY_URL_SERVER}`;
    authorizationToken = customReq.authorizationToken;
  } else {
    // Client side
    locale = Router.router?.locale;
    baseURL = `${process.env.GATEWAY_URL_CLIENT}`;
    authorizationToken = Cookies.get("auth._token.local");
  }

  locale = transcodeLocale(locale || "UNKNOWN", "icu", "iso3166");

  const headers: AxiosRequestHeaders = {
    "X-Locale": locale,
  };

  if (authorizationToken) {
    headers.Authorization = authorizationToken;
  }

  const httpClient = axios.create({
    baseURL,
    headers,
  });

  // Add custom interceptors and config here

  return httpClient;
};

export default hybridHttpClient;
